import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/app/Providers.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Roboto_Flex\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-robotoflex\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
